export class Shape {

  // private color;
  // private x = 150;
  // private y = 150;
  // private z = 60;

  public name = 'Square';
  public id;

  constructor(/*private ctx: CanvasRenderingContext2D, private localName = 'square'*/) {
    // this.name = localName;
  }

  // draw(x: number, y: number, z: number) {
  //   this.ctx.fillRect(z * x, z * y, z, z);
  // }

  draw() {
    // this.ctx.fillStyle = this.color;
    // this.ctx.fillRect(this.x, this.y, this.z, this.z);
    // // console.log(this.z * this.x, this.z * this.y, this.z, this.z);
    // this.setText();
  }

  drawOnPosition(xx, yy) {
    // this.ctx.fillStyle = this.color;
    // this.x = xx;
    // this.y = yy;
    // this.ctx.fillRect(this.x, this.y, this.z, this.z);
    // // console.log(this.z * this.x, this.z * this.y, this.z, this.z);
    // this.setText();
  }

  setText() {
    // this.ctx.fillStyle = "#00F";
    // this.ctx.strokeStyle = "#F00";
    // this.ctx.font = "italic 10pt Arial";
    // this.ctx.fillText(this.name, this.x + 10, this.y + 25);
  }

  drawOnDefPosition() {
    // this.ctx.fillStyle = this.color;
    // // this.x = xx;
    // // this.y = yy;
    // this.ctx.fillRect(this.x, this.y, this.z, this.z);
    // // console.log(this.z * this.x, this.z * this.y, this.z, this.z);
    // this.setText();
  }

  setName(name) {
    //this.name = name;
  }

  putThisCoords(xx, yy) {
    // this.x = xx;
    // this.y = yy;
    // this.removePicture();
    // this.ctx.fillStyle = this.color;
    // // this.x = xx;
    // // this.y = yy;
    // this.ctx.fillRect(xx, yy, this.z, this.z);
    // this.setText();
  }

  removePicture() {
    // this.ctx.fillStyle = 'white';
    // this.ctx.fillRect(this.x, this.y, this.z, this.z);
  }

  moveRight() {
    // this.x+=10;
    // this.removePicture();
    // // this.x+=10;
    // this.draw();
  }

  moveLeft() {
    // this.x-=10;
    // this.removePicture();
    // // this.x-=10;
    // this.draw();
  }

  moveUp() {
    // this.y-=10;
    // this.removePicture();
    // // this.y-=10;
    // this.draw();
  }

  moveDown() {
    // this.y+=10;
    // this.removePicture();
    // // this.y+=10;
    // this.draw();
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**
   * save object state into String
   */
  serialization() {}

}
